import React, { PureComponent } from 'react'
import { Modal } from 'react-bootstrap'

class ModalPasswordExpiration extends PureComponent {
  constructor (props) {
    super(props)
    this.handleChangePassword = this.handleChangePassword.bind(this)
  }

  handleChangePassword () {
    this.props.actions.closePasswordExpirationSoon()
    this.props.actions.goToProfile()
  }

  render () {
    const { t, showPasswordExpirationSoon, actions: { closePasswordExpirationSoon } } = this.props
    const tKey = 'HEADER.MODAL_PASSWORD_EXPIRATION.'
    return (
      <Modal
        id='modalPasswordExpiration'
        className={'custom-modal password-expiration-modal'}
        show={Boolean(showPasswordExpirationSoon)}
        onHide={closePasswordExpirationSoon}
        backdrop={'static'}
      >
        <Modal.Header closeButton>
          <Modal.Title className={'title center'}>
            <span>{t(`${tKey}PASSWORD_EXPIRATION_WARNING`)}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span dangerouslySetInnerHTML={{ __html: t(`${tKey}PASSWORD_EXPIRATION_RECOMMENDATION`) }} />
        </Modal.Body>
        <Modal.Footer>
          <div className="btnContainer">
            <button
              className={'_Btn btn new'}
              onClick={this.handleChangePassword}
            >
              <i className="ico-home"></i> {t(`${tKey}PASSWORD_EXPIRATION_CHANGE_BUTTON`)}
            </button>
            <button
              className="_Btn accept"
              onClick={closePasswordExpirationSoon}
            >
              <i className="iDocIcon-last-update"></i> {t(`${tKey}PASSWORD_EXPIRATION_POSTPONE_BUTTON`)}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default ModalPasswordExpiration
